<mat-toolbar class="modern-header">
    <div class="header-left">
        <span class="toolbar-logo">
            <a routerLink="home" class="toolbar-logo" aria-label="Homepage">
                <img [src]="logo" alt="True Data Logo" />
            </a>
        </span>

        <!-- Main Navigation Menu -->
        <nav class="main-nav">
            <ng-container *ngFor="let item of menuItems; let i = index">
                <!-- Menu item with submenus -->
                <div *ngIf="item.submenus && item.submenus.length > 0" class="nav-dropdown">
                    <button mat-button [matMenuTriggerFor]="getMenuByIndex(i)" class="nav-link" [class.active-nav-link]="isSubmenuActive(item.submenus)">
                        <mat-icon class="nav-icon">{{ item.iconClass }}</mat-icon>
                        <span class="nav-text">{{ item.title }}</span>
                        <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #navMenu="matMenu" [xPosition]="'before'">
                        <a *ngFor="let submenu of item.submenus" [routerLink]="submenu.page" routerLinkActive="active-submenu" mat-menu-item class="submenu-item">
                            <mat-icon *ngIf="submenu.iconClass">{{ submenu.iconClass }}</mat-icon>
                            <span>{{ submenu.title }}</span>
                        </a>
                    </mat-menu>
                </div>

                <!-- Regular menu item without submenus -->
                <a *ngIf="!item.submenus || item.submenus.length === 0" [routerLink]="item.page" routerLinkActive="active-nav-link" class="nav-link">
                    <mat-icon class="nav-icon">{{ item.iconClass }}</mat-icon>
                    <span class="nav-text">{{ item.title }}</span>
                </a>
            </ng-container>
        </nav>
    </div>

    <!-- Entity Selector - Show on New Data Explorer page -->
    <div class="header-center" *ngIf="isNewDataExplorerPage">
        <app-entity-selector class="w-100" (entitySelected)="onEntitySelected($event)"></app-entity-selector>
    </div>

    <div class="header-right">
        <!-- Theme Toggle -->
        <div class="theme-toggle">
            <label class="custom-switch">
                <input type="checkbox" id="togBtn" [(ngModel)]="themeState" (ngModelChange)="onThemeStateChange($event)" />
                <div class="slider round">
                    <span class="on">Dark</span>
                    <span class="off">Light</span>
                </div>
            </label>
        </div>

        <!-- User Profile Section -->
        <div class="user-profile">
            <!-- User Menu Dropdown -->
            <div class="user-menu">
                <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-trigger">
                    <mat-icon>account_circle</mat-icon>
                </button>
                <mat-menu #userMenu="matMenu" class="user-dropdown-menu">
                    <div class="menu-header" *ngIf="userInfo">
                        <div class="menu-user-name">{{ getDisplayName() }}</div>
                        <div class="menu-user-email">{{ getUserEmail() }}</div>
                    </div>
                    <mat-divider></mat-divider>
                    <a *ngFor="let item of menuItemsFooter" [routerLink]="item.page" mat-menu-item class="menu-item">
                        <mat-icon>{{ item.iconClass }}</mat-icon>
                        <span>{{ item.title }}</span>
                    </a>
                    <mat-divider></mat-divider>
                    <div class="menu-version">
                        <span class="version-label">Version</span>
                        <span class="version-number">{{ appVersion }}</span>
                    </div>
                </mat-menu>
            </div>
        </div>
    </div>
</mat-toolbar>
